// The island quick-view's TAP rule (`native-apps/shared/outreach-needs-you/contract.json` rule 4): tapping a task
// card outside its chips, reply box and links opens THAT task and closes the panel — never only the latter. A tap
// that landed on one of the card's own controls is that control's, and the card leaves it alone (the DS Card's
// nested-control rule: one `closest` guard on the card, not a `stopPropagation` on every control). Pure, so the rule
// is testable without a DOM.

/** Everything inside a card that acts on its own. */
export const CARD_CONTROL_SELECTOR =
  'a,button,input,textarea,select,label,[role="button"],[role="radio"],[role="checkbox"],[contenteditable="true"]';

/** Whether a tap that landed on `target` (the event's target) should open the card's task. */
export function cardTapOpensTask(target: { closest(selector: string): unknown } | null | undefined): boolean {
  if (!target) return true;
  return !target.closest(CARD_CONTROL_SELECTOR);
}

/** Where opening an OPEN ASK card goes (the card tap, or a prompt-less card's button): a goal's QUESTION (an ask with a
 *  prompt and a `goalId`) opens that goal — the question was never posted into the chat it was raised from, and the
 *  goal is where it reads in full — otherwise the chat the ask was put in, and with no chat the Action needed tab.
 *  Pure; shared 1:1 with iOS `AgentsQuickView.askOpenTarget` and Android `islandAskOpenTarget`. */
export type AskOpenTarget = { kind: 'goal'; goalId: string } | { kind: 'conversation'; conversationId: string } | { kind: 'tasksTab' };

export function askOpenTarget(ask: { prompt?: unknown; goalId?: string; conversationId?: string }): AskOpenTarget {
  const goalId = ask.prompt ? ask.goalId?.trim() : undefined;
  if (goalId) return { kind: 'goal', goalId };
  const conversationId = ask.conversationId?.trim();
  return conversationId ? { kind: 'conversation', conversationId } : { kind: 'tasksTab' };
}
